"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleEventList = void 0;
const ste_core_1 = require("ste-core");
const SimpleEventDispatcher_1 = require("./SimpleEventDispatcher");
/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class SimpleEventList extends ste_core_1.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new SimpleEventDispatcher_1.SimpleEventDispatcher();
    }
}
exports.SimpleEventList = SimpleEventList;
